import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/community',
    name: 'community',
    component: () => import( '../components/Community.vue')
  },
  {
    path: '/',
    name: 'home',
    component: () => import( '../components/Home.vue')
  },
  
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
